module.exports = __webpack_public_path__ + "img/mobile-screenshot.2af03ef7.png";